export default {"src":"/_next/static/media/republique-francaise.297d1057.svg","height":111,"width":127};